(function ($) {   
    /**
     * Compte le nombre de caractère restant dans le un TextArea
     */
    $.fn.textAreaCountCaractere = function () {
        $(this).on('keyup', function () {
            var max = $(this).attr('maxlength');
            var len = $(this).val().length;
            if (len >= max) {
                $($(this).closest('.form__controls-inner').find('.charNum')).html('0 caractère restant');
            } else {
                var char = max - len;
                $($(this).closest('.form__controls-inner').find('.charNum')).html(char + ' caractères restants');
            }
        });
    };
})(jQuery);    

